import { useContext } from 'react';

import { PageIncludeContext } from '../contexts/PageIncludeContext.tsx';
import type { PageIncludeStackEntry } from '../contexts/PageIncludeContext.tsx';

export const usePageIncludeStack = (): {
	includeStack: readonly PageIncludeStackEntry[];
	getCircularEntry: (contentId: string) => PageIncludeStackEntry | null;
} => {
	const { includeStack } = useContext(PageIncludeContext);

	const getCircularEntry = (contentId: string): PageIncludeStackEntry | null => {
		return includeStack.find((entry) => entry.contentId === contentId) ?? null;
	};

	return { includeStack, getCircularEntry };
};
